import Ruler from './ruler.component';
export default Ruler;
